import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthToken, AppConfig } from '@boels/models';
import { BehaviorSubject, Observable, of, switchMap, tap } from 'rxjs';

interface AuthResponse {
  token_data: AuthToken;
  token_aquired_ts: number;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  private environment = inject<AppConfig>('ENVIRONMENT' as any);

  #sapAuthToken = new BehaviorSubject<AuthResponse | undefined>(undefined);

  getToken(): Observable<AuthToken> {
    return this.#sapAuthToken.pipe(
      switchMap((authResponse) => {
        if (
          authResponse &&
          !this.#tokenExpired(
            authResponse.token_aquired_ts,
            authResponse.token_data.expires_in,
          )
        )
          return of(authResponse.token_data);
        let params = new HttpParams();
        params = params.appendAll({
          grant_type: this.environment.auth.grant_type,
          client_id: this.environment.auth.client_id,
          client_secret: this.environment.auth.client_secret,
          scope: this.environment.auth.scope,
        });

        return this.http
          .post<AuthToken>(
            this.environment.backend.occ.baseUrl +
              '/authorizationserver/oauth/token',
            params,
          )
          .pipe(
            tap((token) => {
              this.#sapAuthToken.next({
                token_data: token,
                token_aquired_ts: Date.now(),
              });
            }),
          );
      }),
    );
  }

  #tokenExpired(aquireTs: number, expires_in: number): boolean {
    return aquireTs + expires_in * 1000 < Date.now();
  }
}
